import React from "react";
import { HiOutlineLibrary } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneMinistry } from "../../../lib/sysNavigation/SysNavigation";

type MinistryRow = {
  ministry_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<MinistryRow>
    type={_TYPES_.MINISTRY}
    title="Ministries"
    subtitle="Government ministries listed on the public site."
    icon={<HiOutlineLibrary className="h-5 w-5" />}
    addRoute="/data/ministry/add"
    editRoute="/data/ministry/edit"
    pushOne={pushOneMinistry}
    dataKey="ministries"
    countKey="ministriesCount"
    idField="ministry_id"
  />
);

export default Overview;
